(() => {
  const ROOT_SELECTOR = '[data-hr-faq-owned]';
  const TAB_ACTIVE_CLASSES = [
    'r-imnjrf',
    'r-64jhgo',
    'r-11f01ea',
    'r-1sovze1',
    'r-7zj333'
  ];

  const setCollapsibleState = (root, trigger, content, open) => {
    trigger.setAttribute('aria-expanded', String(open));
    root.dataset.state = open ? 'open' : 'closed';
    content.dataset.state = open ? 'open' : 'closed';
    content.hidden = !open;
  };

  const initializeCollapsibles = (root) => {
    root.querySelectorAll('[data-replo-collapsible]').forEach((collapsible) => {
      const trigger = collapsible.querySelector(':scope > [role="button"][aria-controls]');
      if (!trigger) return;

      const content = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!content || !collapsible.contains(content)) return;

      setCollapsibleState(
        collapsible,
        trigger,
        content,
        trigger.getAttribute('aria-expanded') === 'true'
      );

      if (collapsible.dataset.hrFaqInitialized === 'true') return;
      collapsible.dataset.hrFaqInitialized = 'true';

      const toggle = () => {
        setCollapsibleState(
          collapsible,
          trigger,
          content,
          trigger.getAttribute('aria-expanded') !== 'true'
        );
      };

      trigger.addEventListener('click', toggle);
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
        event.preventDefault();
        toggle();
      });
    });
  };

  const initializeTabs = (root) => {
    const triggers = [...root.querySelectorAll('[data-replo-tabs-trigger="true"]')];
    if (!triggers.length) return;

    const activate = (selected) => {
      triggers.forEach((trigger, index) => {
        const active = trigger === selected;
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        const visual = trigger.firstElementChild;

        trigger.setAttribute('aria-selected', String(active));
        trigger.dataset.state = active ? 'active' : 'inactive';
        trigger.tabIndex = active ? 0 : -1;
        if (visual) {
          visual.classList.remove(...TAB_ACTIVE_CLASSES);
          if (active) visual.classList.add(TAB_ACTIVE_CLASSES[index]);
        }

        if (!panel) return;
        panel.dataset.state = active ? 'active' : 'inactive';
        panel.hidden = !active;
        panel.style.display = active ? 'contents' : 'none';
      });
    };

    triggers.forEach((trigger, index) => {
      if (trigger.dataset.hrFaqTabInitialized === 'true') return;
      trigger.dataset.hrFaqTabInitialized = 'true';

      trigger.addEventListener('click', () => activate(trigger));
      trigger.addEventListener('keydown', (event) => {
        let nextIndex = null;
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = index + 1;
        if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = index - 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = triggers.length - 1;
        if (nextIndex === null) return;

        event.preventDefault();
        const next = triggers[(nextIndex + triggers.length) % triggers.length];
        activate(next);
        next.focus();
      });
    });

    activate(triggers.find((trigger) => trigger.getAttribute('aria-selected') === 'true') || triggers[0]);
  };

  const initialize = (root) => {
    initializeTabs(root);
    initializeCollapsibles(root);
  };

  const initializeAll = (container = document) => {
    if (container.matches?.(ROOT_SELECTOR)) initialize(container);
    container.querySelectorAll?.(ROOT_SELECTOR).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
